import React from 'react';
import { styled } from '@linaria/react';
import { COLORS, Icon, Tooltip } from '@livecommerce/design-system';

const IconWrapper = styled.div`
  width: 22px;
  height: 22px;

  svg {
    color: ${(params) => params.color};
    width: 100%;
    height: 100%;
  }
`;

const IconFlair = ({ name, className, title, color = COLORS.red_400 }) => {
  return (
    <IconWrapper className={className} color={color} title={title}>
      <Icon name={name} />
    </IconWrapper>
  );
};

const CircleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: ${(params) => params.size};
  height: ${(params) => params.size};

  background-color: ${(params) => params.color};

  border-radius: 50%;
`;

const Circle = styled.div`
  width: ${(params) => params.size};
  height: ${(params) => params.size};
  background-color: ${(params) => params.color};
  border-radius: 50%;
`;

const StyledTooltip = styled(Tooltip)`
  top: 0;
  right: 0;
  margin-right: 4px;
`;

const CircleFlair = ({
  className,
  title,
  outerColor = COLORS.light_000,
  size = '16px',
  color = COLORS.yellow_300,
  innerSize = '12px',
  tooltipText,
  tooltipPosition = 'top',
  minWidth,
}) => {
  const circleContent = (
    <CircleWrapper className={className} color={outerColor} size={size} title={!tooltipText ? title : undefined}>
      <Circle size={innerSize} color={color} />
    </CircleWrapper>
  );

  if (tooltipText) {
    return (
      <StyledTooltip tooltipText={tooltipText || title} tooltipPosition={tooltipPosition} minWidth={minWidth}>
        {circleContent}
      </StyledTooltip>
    );
  }

  return circleContent;
};

// The most used Flair is the one that is positioned at the top right corner of a component.
const TopRightFlair = styled(CircleFlair)`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
`;

export { IconFlair, CircleFlair, TopRightFlair };
